import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/form-listing",
    name: "Forms",
    component: () => import("./formListing.vue"),
  },
] satisfies RouteRecordRaw[];
